<template>
  <section class="dashboard pb-5">
    <div class="page-header">
      <nav aria-label="breadcrumb"></nav>
    </div>
    <div class="row mb-4">
      <div v-if="hasPermission('Voir_module_patient')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/patients/list">
            <img src="@/assets/images/patients.png" style="width: 25%" class="mt-4 mb-1 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Patients</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/patients.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Patients</h6>
          </div>
        </div>
      </div>
      <div v-if="hasPermission('Voir_module_mouvement')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/movments/list">
            <img src="@/assets/images/movment.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Mouvements</h6>
            </div>
          </router-link>
        </div>
      </div>

      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/movment.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Mouvements</h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_services_medicaux')" class="col-md-2 mb-2">
        <div class="card card-img-holder text-black text-center">
          <router-link to="/medical-services/urgences">
            <img src="@/assets/images/actsmedicaux.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Services Médicaux</h6>
            </div>
          </router-link>
        </div>
      </div>

      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/actsmedicaux.png" style="width: 25%; opacity: 0.5"
            class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Services Médicaux</h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_pharmacie')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">

          <button @click="selectCashRegisterP" class="bien">
            <img src="@/assets/images/pharmacie.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Pharmacies</h6>
            </div>
          </button>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/pharmacie.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Pharmacies</h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_caisse')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <button @click="selectCashRegisterA" class="bien">
            <img src="@/assets/images/treasury.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Caisses</h6>
            </div>
          </button>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/treasury.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Caisses</h6>
          </div>
        </div>
      </div>
      <div v-if="hasPermission('Voir_module_facturation')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/service/facturation">
            <img src="@/assets/images/facture.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Facturations</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/facture.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Facturations</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div v-if="hasPermission('Voir_module_hospitalisation')" class="col-md-2 col-sm-6 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/hospitalization/bed/list">
            <img src="@/assets/images/hopital.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Hospitalisations</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/hopital.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Hospitalisations</h6>
          </div>
        </div>
      </div>
      <div v-if="hasPermission('Voir_module_recouvrement_et_remboursement')" class="col-md-2 col-sm-6 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/rembourse_recouvre/recouvrement_patient">
            <img src="@/assets/images/money-flow.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="px-3 py-2 text-center">
              <h6 class="font-weight-bold text-black">Recouvrements et Remboursements</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/money-flow.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Recouvrements et Remboursements</h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_stock')" class="col-md-2 col-sm-6 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/medicaments/list">
            <img src="@/assets/images/package.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="px-3 py-2 text-center">
              <h6 class="font-weight-bold text-black">Stocks / Consommables</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/package.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Stocks / Consommables</h6>
          </div>
        </div>
      </div>
      <div v-if="hasPermission('Voir_module_ressource_humaine')" class="col-md-2 col-sm-6 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="/grh/list">
            <img src="@/assets/images/teamwork.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="px-3 py-2 text-center">
              <h6 class="font-weight-bold text-black">Ressources Humaines</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/teamwork.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Ressources Humaines</h6>
          </div>
        </div>
      </div>
      <div v-if="hasPermission('Voir_module_assurance')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="priseencharge/list">
            <img src="@/assets/images/assurancee.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Assurances</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/assurancee.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Assurances</h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_rendezvous')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <router-link to="#">
            <img src="@/assets/images/calendrier.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="p-3 text-center">
              <h6 class="font-weight-bold text-black">Rendez-vous</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/calendrier.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Rendez-vous</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <!--<div v-if="hasPermission('Voir_module_profil_du_centre')" class="col-md-2 col-sm-6 mb-2">
        <div style="min-height:130px;" class="card card-img-holder text-black text-center ">
          <router-link to="#">
            <img src="@/assets/images/user.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class=" p-3  text-center">
              <h6 class="font-weight-bold text-black"> Profil du centre </h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height:130px;" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/user.png" style="width: 25%; opacity: 0.5;" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Profil du centre </h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_petite_caisse')" class="col-md-2 col-sm-6 mb-2">
        <div style="min-height:130px;" class="card card-img-holder text-black text-center">
          <router-link to="#">
            <img src="@/assets/images/money.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class=" p-3  text-center">
              <h6 class="font-weight-bold text-black"> Petite caisse </h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height:130px;" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/money.png" style="width: 25%; opacity: 0.5;" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Petite caisse</h6>
          </div>
        </div>
      </div>-->

      <div v-if="hasPermission('Voir_module_rapport_et_statistique')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-center bg-success">
          <router-link to="/rapport_statistique/list">
            <img src="@/assets/images/data-report.png" style="width: 25%; color: white"
              class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="py-2 px-3 text-center">
              <h6 class="font-weight-bold text-white">Rapports et Statistiques</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/data-report.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Rapports et Statistiques</h6>
          </div>
        </div>
      </div>

      <div v-if="hasPermission('Voir_module_configuration_et_parametrage')" class="col-md-2 mb-2">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center bg-danger">
          <router-link to="/configuration/store/list">
            <img src="@/assets/images/parametrage.png" style="width: 25%" class="mt-4 mb-2 ml-auto mr-auto" />
            <div class="px-3 py-2 text-center">
              <h6 class="font-weight-bold text-white">Configuration et Paramétrage</h6>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="col-md-2 mb-2 disabled-module">
        <div style="min-height: 130px" class="card card-img-holder text-black text-center">
          <img src="@/assets/images/parametrage.png" style="width: 25%; opacity: 0.5" class="mt-4 mb-2 ml-auto mr-auto" />
          <div class="p-3 text-center">
            <h6 class="font-weight-bold text-black">Configuration et Paramétrage</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="selectcashprestation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document" style="width: 50%">
        <h4 class="card-title text-white p-3 text-center col-12"
          style="background-color: #0b5d3f; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1)">
          Choisir une caisse
        </h4>
        <div class="modal-content" style="margin-top: -17px !important">
          <div class="modal-body">
            <div class="col-md-12 col-lg-12">
              <form class="forms-sample">
                <div class="">
                  <div class="form-group controls">
                    <label for="exampleFormControlSelect1">Caisses <span style="color: red">*</span></label>

                    <select v-model="selectedCashRegisterA" class="form-control mb-3" id=""
                      style="height: 45px; font-size: 15px">
                      <option value="">Sélectionner</option>
                      <option v-for="cashRegister in listCashRegisterA" :value="cashRegister.id" :key="cashRegister.id">
                        {{ cashRegister.designation }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex justify-content-between col-md-12 col-lg-12 flex-row mt-n3">
              <button class="btn btn-danger btn-medpay-gray ml-2 btn-rounded" data-dismiss="modal"
                style="width: 150px !important">
                Annuler
              </button>
              <button @click="chooseCashRegisterA" class="btn btn-success btn-medpay-green btn-rounded"
                style="width: 150px !important">
                Continuer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="selectcashpharmacie" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document" style="width: 50%">
        <h4 class="card-title text-white p-3 text-center col-12"
          style="background-color: #0b5d3f; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1)">
          Choisir une caisse
        </h4>
        <div class="modal-content" style="margin-top: -17px !important">
          <div class="modal-body">
            <div class="col-md-12 col-lg-12">
              <form class="forms-sample">
                <div class="">
                  <div class="form-group controls">
                    <label for="exampleFormControlSelect1">Caisses <span style="color: red">*</span></label>

                    <select v-model="selectedCashRegisterP" class="form-control mb-3" id=""
                      style="height: 45px; font-size: 15px">
                      <option value="">Sélectionner</option>
                      <option v-for="cashRegister in listCashRegisterP" :value="cashRegister.id" :key="cashRegister.id">
                        {{ cashRegister.designation }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex justify-content-between col-md-12 col-lg-12 flex-row mt-n3">
              <button class="btn btn-danger btn-medpay-gray ml-2 btn-rounded" data-dismiss="modal"
                style="width: 150px !important">
                Annuler
              </button>
              <button @click="chooseCashRegisterP" class="btn btn-success btn-medpay-green btn-rounded"
                style="width: 150px !important">
                Continuer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import "../../../node_modules/bootstrap/dist/js/bootstrap.js"; // tres important pour le modal
import "../../../node_modules/bootstrap/dist/js/bootstrap.min.js"; // tres important pour le modal

import { useToast, POSITION } from "vue-toastification";
import { caisseService } from "@/_services";

export default {
  name: "acceuil",
  data() {
    return {
      time1: null,
      selectedCashRegisterA: "",
      selectedCashRegisterP: "",
      listCashRegisterA: [],
      listCashRegisterP: [],
      // permission: JSON.parse(localStorage.getItem("permission")),
      user: JSON.parse(localStorage.getItem("user")),
      permission: JSON.parse(localStorage.getItem("permission")) || [], // Initialisation avec un tableau vide
      // accessToken: JSON.parse(localStorage.getItem("access_token")) || null,
    };
  },

  mounted() {
  
    // this.getCashRegisterCashier();

    caisseService
      .getAllCaisse()
      .then((response) => {
        console.log(response.data.data);
        this.listCashRegister = response.data.data;

        this.listCashRegisterA = this.listCashRegister.filter(
          (item) => item.type == "A"
        );
        this.listCashRegisterP = this.listCashRegister.filter(
          (item) => item.type == "P"
        );

      })
      .catch((error) => {
        console.log(error);
      });
  },

  methods: {
    hasPermission(permission) {
      return this.permission.includes(permission);
    },

    selectCashRegisterA() {
      const user_id = this.user.id;

      $("#selectcashprestation").modal("show");
    },

    selectCashRegisterP() {
      const user_id = this.user.id;

      $("#selectcashpharmacie").modal("show");
    },

    chooseCashRegisterA() {
      if (this.selectedCashRegisterA == "") {
        this.$toast.error("Selectionnez une caisse !", {
          position: "top-right",
          timeout: 3000,
          style: {
            background: "#ff0000", // Couleur de fond rouge pour l'erreur
            color: "#fff", // Couleur du texte
            fontWeight: "bold",
          },
        });
      } else {
        console.log("this.selectedCashRegister");
        console.log(this.selectedCashRegisterA);

        const user_id = this.user.id;
        caisseService
          .chooseCashRegister(this.selectedCashRegisterA, user_id)
          .then((response) => {
            console.log("Caisse selectionnée");
            console.log(response.data.data);

            // Remplacez '/nouvelle-page' par le chemin de la page vers laquelle vous souhaitez rediriger.
            this.$toast.success("Caisse selectionnée avec succès !", {
              position: POSITION.TOP_RIGHT,
              timeout: 3000,
              bodyStyle: {
                borderRadius: "10px",
                backgroundColor: "#f0f0f0",
                color: "#333",
                fontWeight: "bold",
              },
            });

            // this.$router.push('/payement/create');
            this.$router.push("/caisse/payement");
            $("#selectcashprestation").modal("hide");
            // this.listCashRegisterCashier = response.data.data;
          })
          .catch((error) => {
            console.log(error);

            if (error.response.status == 422 && error.response.data.error) {
              this.$toast.error(error.response.data.error, {
                position: "top-right",
                timeout: 3000,
                style: {
                  background: "#ff0000",
                  color: "#fff",
                  fontWeight: "bold",
                },
              });
            } else {
              // Gérez d'autres erreurs ici
              console.error("Une erreur inattendue s'est produite :", error);
            }

          });
      }
    },


    chooseCashRegisterP() {
      if (this.selectedCashRegisterP == "") {
        this.$toast.error("Selectionnez une caisse !", {
          position: "top-right",
          timeout: 3000,
          style: {
            background: "#ff0000", // Couleur de fond rouge pour l'erreur
            color: "#fff", // Couleur du texte
            fontWeight: "bold",
          },
        });
      } else {
        const user_id = this.user.id;
        caisseService
          .chooseCashRegister(this.selectedCashRegisterP, user_id)
          .then((response) => {
            console.log("Caisse selectionnée");
            console.log(response.data.data);

            // Remplacez '/nouvelle-page' par le chemin de la page vers laquelle vous souhaitez rediriger.
            this.$toast.success("Caisse selectionnée avec succès !", {
              position: POSITION.TOP_RIGHT,
              timeout: 3000,
              bodyStyle: {
                borderRadius: "10px",
                backgroundColor: "#f0f0f0",
                color: "#333",
                fontWeight: "bold",
              },
            });

            // this.$router.push('/payement/create');
            this.$router.push("/pharmacy/sale");
            $("#selectcashpharmacie").modal("hide");
            // this.listCashRegisterCashier = response.data.data;
          })
          .catch((error) => {
            console.log(error);

            if (error.response.status == 422 && error.response.data.error) {
              this.$toast.error(error.response.data.error, {
                position: "top-right",
                timeout: 3000,
                style: {
                  background: "#ff0000",
                  color: "#fff",
                  fontWeight: "bold",
                },
              });
            } else {
              // Gérez d'autres erreurs ici
              console.error("Une erreur inattendue s'est produite :", error);
            }

          });
      }
    },
  },
};
</script>
<!-- <script>
export default {
  name: "acceuil",
  data() {
    return {
      time1: null,
      user: null,
    };
  },
  mounted() {
    this.fetchUserFromLocalStorage();
  },
  computed: {
    isUserRoleAdmin() {
      return (id) => this.user && this.user.role_id && this.user.role_id === id;
    },
  },
  methods: {
    fetchUserFromLocalStorage() {
      const user = localStorage.getItem("user");
      if (user) {
        this.user = JSON.parse(user);
      }
    },
  },
};
</script> -->

<style scoped>
.text-black:hover {
  transition: 1s;
  background: #a5ddbe;
}

/* .modal{
  z-index: 1 !important;
} */

.bien {
  border: none;
  background: #fff;
  transition: background 0.3s;
  /* Ajoute une transition pour une animation en douceur */
}

.bien:hover {
  background: rgb(165, 221, 190);
  /* Couleur verte (changez-la en fonction de votre choix) */
}

.disabled-module {
  opacity: 0.5;
  /* ou une autre propriété pour indiquer qu'ils sont désactivés */
  pointer-events: none;
  /* pour désactiver les interactions avec les éléments */
  /* Ajoutez d'autres styles pour indiquer visuellement que le module est désactivé */
}
</style>
